import React, { useState, useEffect } from "react";
import headers from "../../Data/Tables/Reports/Reports/headers";
import Header from "../../Componets/Header";
import Menus from "../../Componets/Menus";
import ProductIcon from "../../Assets/Svg/products";
import InventoryIcon from "../../Assets/Svg/inventory";
import BillingIcon from "../../Assets/Svg/billing";
import SalesIcon from "../../Assets/Svg/sales";
import PurchaseIcon from "../../Assets/Svg/purchase";
import ExpenseIcon from "../../Assets/Svg/expense";
import CustomerIcon from "../../Assets/Svg/customer";
import SupplierIcon from "../../Assets/Svg/supplier";
import DonwloaduploadIcon from "../../Assets/Svg/donwloadupload";
import { useNavigate } from "react-router-dom";
import UploadIcon from "../../Assets/Svg/upload";
import ArrowrightIcon from "../../Assets/Svg/arrowright";
import FeatureLockWrapper from "../../Componets/FeatureLocksWrapper";
import ScrollWrapper from "../../Componets/ScrollWrapper";

const Importexport = () => {
  const navigate = useNavigate();
  const [isUnlocked, setIsUnlocked] = useState(false);

  useEffect(() => {
    const fetchFeatureUnlocks = async () => {
      const branchImport = await FeatureLockWrapper.isFeatureUnlocked(
        "branch_to_branch_import",
      );
      setIsUnlocked(branchImport);
    };
    fetchFeatureUnlocks();
  }, []);

  let header = headers;

  const formdata = async (data) => {
    console.log(data);
  };

  const menu = [
    {
      icon: <ProductIcon width={22} height={22} />,
      name: "Products",
      options: [
        {
          icon: <DonwloaduploadIcon />,
          name: "Products",
          description: "Import/Export",
          url: "/app/importexport/products",
        },
        ...(isUnlocked
          ? [
              {
                icon: <UploadIcon width={16} />,
                name: "Branch Products",
                description: "Bulk upload",
                url: "/app/importexport/branchproducts",
              },
            ]
          : []),
      ],
    },
    {
      icon: <InventoryIcon width={22} height={22} />,
      name: "Inventory",
      options: [
        {
          icon: <DonwloaduploadIcon />,
          name: "Inventory",
          description: "Import/Export",
          url: "/app/importexport/inventory",
        },
      ],
    },
    {
      icon: <ProductIcon width={22} height={22} />,
      name: "Customers and Suppliers",
      options: [
        {
          icon: <CustomerIcon width={18} height={18} />,
          name: "Customers",
          description: "Import/Export",
          url: "/app/importexport/customers",
        },
        {
          icon: <SupplierIcon width={18} height={18} />,
          name: "Suppliers",
          description: "Import/Export",
          url: "/app/importexport/suppliers",
        },
      ],
    },
    {
      icon: <ProductIcon width={22} height={22} />,
      name: "Expense",
      options: [
        {
          icon: <CustomerIcon width={18} height={18} />,
          name: "Expense",
          description: "Import/Export",
          url: "/app/importexport/expenses",
        },
      ],
    },
    {
      icon: <ProductIcon width={22} height={22} />,
      name: "Sales",
      options: [
        {
          icon: <CustomerIcon width={18} height={18} />,
          name: "Invoices",
          description: "Import/Export",
          url: "/app/importexport/invoices",
        },
         {
          icon: <CustomerIcon width={18} height={18} />,
          name: "Returns",
          description: "Import/Export",
          url: "/app/importexport/invoice-returns",
        },
         {
          icon: <CustomerIcon width={18} height={18} />,
          name: "Quotes",
          description: "Import/Export",
          url: "/app/importexport/quotes",
        },
         {
          icon: <CustomerIcon width={18} height={18} />,
          name: "Credit Notes",
          description: "Import/Export",
          url: "/app/importexport/credit-notes",
        },
      ],
    },
      {
      icon: <ProductIcon width={22} height={22} />,
      name: "Purchases",
      options: [
        {
          icon: <CustomerIcon width={18} height={18} />,
          name: "GRN",
          description: "Import/Export",
          url: "/app/importexport/grn",
        },
         {
          icon: <CustomerIcon width={18} height={18} />,
          name: "Returns",
          description: "Import/Export",
          url: "/app/importexport/purchase-returns",
        },
         {
          icon: <CustomerIcon width={18} height={18} />,
          name: "Debit Notes",
          description: "Import/Export",
          url: "/app/importexport/debit-notes",
        },
      ],
    },
  ];

  const handleClick = (url) => {
    if (url) {
      navigate(url);
    }
  };

  return (
    <Header header={header} formdata={formdata}>
      <ScrollWrapper>
        <div>
          {menu?.map((value, index) => {
            return (
              <div
                className={
                  index > 0
                    ? "mt-6 my-2 bg-white rounded-md p-4"
                    : "bg-white my-2 bg-white rounded-md p-4"
                }
              >
                <div className="flex">
                  <div>{value?.icon}</div>
                  <div className="text-medium pl-2">{value?.name}</div>
                </div>
                <div className="mt-4 grid grid-cols-4 gap-4">
                  {value?.options?.map((v, i) => {
                    return (
                      <div
                        className="flex bg-white p-1 rounded-lg border cursor-pointer setting-card hover:bg-gray-100"
                        onClick={() => handleClick(v?.url)}
                      >
                        <div className="p-3 rounded-lg bg-gray-300">
                          <div className="my-auto">{v?.icon}</div>
                        </div>
                        <div className="text-left px-2 my-auto">
                          <div className="text-sm">{v?.name}</div>
                          <div className="text-xs text-gray-400">
                            {v?.description}
                          </div>
                        </div>
                        <div className="float-right ml-auto my-auto text-gray-400 pr-3">
                          <ArrowrightIcon />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </ScrollWrapper>
    </Header>
  );
};

export default Importexport;
